import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';
import MultiDropDown from '../Components/MultiDropdown';

var sessiondata = sessionStorage.getItem("User_Info");
class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            name: '',
            phone: '',
            logo: '',
            city: '',
            zip: '',
            address: '',
            details: '',
            stateAddress: '',
            typeHierarchy: [],
            departmentSelected: [],
            equipmentSelected: [],
            unitSelected: [],
            rating: 0,
            dynamicSelectedType: [],
            isTypeUpdated: false,
            image: '',
            designation: '',
            allFormData: {},
            uniqueID: '',
            alignedTypes: [],
            deletePopup: false,
            errors: {
                // name: '',
                // email: '',
                // cpassword: '',

                // password: '',

            }
        }
    }

    checkRequirement = (name, value) => {
        let errors = this.state.errors;

        switch (name) {
            case 'name':
                errors.name =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;

            // case 'password':
            //     errors.password =
            //         value.length < 8
            //             ? 'Password must be 8 characters long!'
            //             : '';
            //     break;
            // case 'cpassword':
            //     errors.password =
            //         this.state.password !== value
            //             ? 'Password and Confirm Password does not match!'
            //             : '';
            //     break;
            default:
                break;
        }

        this.setState({ errors });
    }

    onChangeInput = (e) => {
        e.preventDefault();

        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                image: reader.result
            });

        };
    }
    getAlignedType = (id) => {
        var data = {
            user_id: id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersfetchTypes`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.data.error === false) {
                    _this.setState({ alignedTypes: response.data.types }, () => _this.getTotalType())


                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getAlignedType(id);
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getTotalType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        var heirarchy = this.state.heirarchy
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    var temparr = [];

                    r.map((list, index) => { temparr.push([]) })
                    _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });

                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }



    submit = (e) => {
        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {


        } else {
            swal("Invalid Input ..!!")
            return
        }

        // if (this.state.password != this.state.cpassword) {
        //     swal("Invalid Password ..!!")
        //     return
        // }
        var getselected = [];
        this.state.dynamicSelectedType.map((list, index) => list.length != 0 ? getselected.push(list.map((li, ind) => li.id)) : undefined)

        var filteredSelectedTypes = [].concat.apply([], getselected);
        filteredSelectedTypes = filteredSelectedTypes.filter((v, i) => filteredSelectedTypes.indexOf(v) == i)
        var x = $('input[name="user_type"]:checked').val()
        if (filteredSelectedTypes.length == 0 && this.state.isTypeUpdated) {
            swal("", "Please select Organizational Structure.", "warning")
            return
        }
        var data = {
            name: this.state.name,
            phone: this.state.phone,
            type_id: filteredSelectedTypes,
            status: this.state.status,
            usertype: x === "SME" ? 1 : 2,
            address: this.state.address,
            id: this.state.id,
            new_profile: this.state.image,
            old_profile: JSON.parse(sessiondata).profile,
            city: this.state.city,
            state: this.state.stateAddress,
            zip: this.state.zip,
            designation: this.state.designation,
            uniqueID: this.state.uniqueID,
            main_status: 1,
            user_update_status: {
                name: this.state.name == JSON.parse(sessiondata).name ? "0" : "1",
                phone: this.state.phone == JSON.parse(sessiondata).phone ? "0" : "1",
                usertype: (x === "SME" ? 1 : 2) == JSON.parse(sessiondata).usertype ? "0" : "1",
                profile: this.state.image == "" ? "0" : "1",
                address: this.state.address == JSON.parse(sessiondata).address ? "0" : "1",
                city: this.state.city == JSON.parse(sessiondata).city ? "0" : "1",
                state: this.state.stateAddress == JSON.parse(sessiondata).state ? "0" : "1",
                zip: this.state.zip == JSON.parse(sessiondata).zip ? "0" : "1",
                types: this.state.isTypeUpdated ? "1" : "0",

            }
        }
       
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        window.location.href = "/create/listuser";
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.submit(e);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    submitDeleteApproved = () => {
        var _this = this;
        var data = {
            name: JSON.parse(sessiondata).name,
            phone: JSON.parse(sessiondata).phone,
            status: 0,
            usertype: JSON.parse(sessiondata).user_type === "SME" ? 1 : 2,
            address: JSON.parse(sessiondata).address,
            id: JSON.parse(sessiondata).login_id,
            old_profile: JSON.parse(sessiondata).profile,
            new_profile: "",
            state: JSON.parse(sessiondata).state,
            city: JSON.parse(sessiondata).city,
            zip: JSON.parse(sessiondata).zip,
            designation: JSON.parse(sessiondata).designation,
            email: JSON.parse(sessiondata).email,
            uniqueID: JSON.parse(sessiondata).uniqueID,
            main_status: 0,
            user_update_status: {
                name: "0",
                phone: "0",
                usertype: "0",
                profile: "0",
                address: "0",
                city: "0",
                state: "0",
                zip: "0",
                types: "0"
            }
        }

        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    _this.setState({ deletePopup: false })
                    swal(response.data.message)
                    if (response.data.error == false) {
                        window.location.href = "/create/listuser";
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.submitDeleteApproved();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    convert = (array) => {
        var map = {};
        for (var i = 0; i < array.length; i++) {
            var obj = Object.assign(array[i], { checked: this.state.alignedTypes.find(x => x.id == array[i].id) ? true : false });
            obj.children = [];


            map[obj.id] = obj;

            var parent_id = obj.parent_id || '-';
            if (!map[parent_id]) {
                map[parent_id] = {
                    children: []
                };

            }
            map[parent_id].children.push(obj);

        }


        return map['-'].children;

    }


    componentDidMount() {

        if (sessiondata != "") {

            this.getAlignedType(JSON.parse(sessiondata).login_id)

            this.setState({
                allFormData: JSON.parse(sessiondata),
                name: JSON.parse(sessiondata).name,
                phone: JSON.parse(sessiondata).phone,
                status: JSON.parse(sessiondata).mainStatus,
                address: JSON.parse(sessiondata).address,
                stateAddress: JSON.parse(sessiondata).state,
                city: JSON.parse(sessiondata).city,
                zip: JSON.parse(sessiondata).zip,
                id: JSON.parse(sessiondata).login_id,
                old_profile: `${SERVER_IP}/icons/${JSON.parse(sessiondata).profile}`,
                new_profile: "",
                user_type: JSON.parse(sessiondata).user_type,
                email: JSON.parse(sessiondata).email,
                designation: JSON.parse(sessiondata).designation,
                uniqueID: JSON.parse(sessiondata).uniqueID,
                user_action: JSON.parse(sessiondata).user_action,


            });
        } else {
            window.location.href = '/create/listuser';
        }


        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }

    onChangeDropdownDepartment = (currentNode, selectedNodes) => {

        this.setState({ departmentSelected: selectedNodes })
    }
    onChangeDropdownEquipment = (currentNode, selectedNodes) => {
        this.setState({ equipmentSelected: selectedNodes })

    }
    onChangeDropdownUnit = (currentNode, selectedNodes) => {
        this.setState({ unitSelected: selectedNodes })
    }
    onAction = (node, action) => {
        console.log('onAction::', action, node)
    }
    onNodeToggle = currentNode => {
        console.log('onNodeToggle::', currentNode)
    }
    onChangeDropdown = (index, currentNode, selectedNodes) => {

        this.state.dynamicSelectedType[index] = selectedNodes;
        this.state.isTypeUpdated = true;
        this.setState(this.state)

    }
    submitDelete = () => {
        this.setState({ deletePopup: true });
    }

    render() {
        
        const { errors } = this.state;
        return (
            <div>
                {this.state.deletePopup ?
                    <div className="cd-popup is-visible" role="alert">
                        <div className="cd-popup-container">
                            <h5>Are you sure you want to delete this user?</h5>
                            {/* <h4 className="child-p">{this.state.selectedQue}</h4> */}
                            <ul className="cd-buttons">
                                <li><a onClick={this.submitDeleteApproved}>Yes</a></li>
                                <li onClick={() => this.setState({ deletePopup: false })}><a>No</a></li>
                            </ul>
                            <a onClick={() => this.setState({ deletePopup: false })} className="cd-popup-close img-replace">Close</a>
                        </div>
                    </div>
                    : null}
                {this.state.user_action == "view" ?
                    <div>
                        <div class="xp-breadcrumbbar">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <h3 className="xp-page-title">User Profile</h3>
                                </div>
                                <div class="col-md-12 col-lg-12">
                                    <div class="xp-breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                            <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li>
                                        </ol>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-4">
                                    <button className="btn btn-primary btn-lg" title="Create new" onClick={() => this.setState({ user_action: "edit" })}><i className="mdi mdi-plus mr-2"></i>Edit User</button>
                                </div>
                            </div>
                            <div className="xp-contentbar">
                                <div className="row">
                                    <div className="">
                                        <div className="card m-b-30">
                                            <div className="card-header bg-primary">
                                                <h5 className="card-title text-white">User Profile</h5>
                                            </div>
                                            <div className="card-body">
                                                <div class="xp-social-profile-middle text-center">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="xp-social-profile-avatar text-center">
                                                                <img src={this.state.old_profile} alt="user-profile" class="rounded-circle img-fluid" style={{ height: "200px" }} />
                                                            </div>
                                                            <div class="xp-social-profile-title">
                                                                <h5 class="my-1 text-black">{this.state.name}</h5>
                                                            </div>
                                                            <div class="xp-social-profile-subtitle">
                                                                <p class="mb-3 text-muted">{this.state.uniqueID}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ul className="profile-list">
                                                    <li><label>Name</label><p>{this.state.name}</p></li>
                                                    <li><label>Email</label><p>{this.state.email}</p></li>
                                                    <li><label>Phone</label><p>{this.state.phone}</p></li>
                                                    <li><label>Address</label>{this.state.address}<p></p></li>
                                                    <li><label>City</label><p>{this.state.city}</p></li>
                                                    <li><label>State</label><p>{this.state.stateAddress}</p></li>
                                                    <li><label>ZIP</label><p>{this.state.zip}</p></li>
                                                    <li><label>User Type</label><p>{this.state.user_type}</p></li>
                                                    <li><label>Designation</label><p>{this.state.designation}</p></li>
                                                    <li><label>ID</label><p>{this.state.uniqueID}</p></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div> : null}

                {this.state.user_action == "edit" ?
                    <div>
                        <div class="xp-breadcrumbbar">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <h3 class="xp-page-title">Edit User</h3>
                                </div>
                                <div class="col-md-12 col-lg-12">
                                    <div class="xp-breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                            <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="xp-contentbar p-30">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card m-b-30">
                                        <div className="card-header bg-primary">
                                            <h5 className="card-title text-white">Edit User</h5>
                                            {/* <h6 className="card-subtitle">Here’s a quick example to demonstrate Bootstrap’s form styles. Keep reading for documentation on required classes, form layout, and more.</h6> */}
                                        </div>
                                        <div className="card-body">
                                            <div className="form-row">
                                                <div className="form-group col-md-12">
                                                    <label for="exampleInputEmail1">Name</label>

                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                        </div>
                                                        <input type="text" onChange={this.onChangeInput} name="name" className="form-control" value={this.state.name} placeholder="Enter User Name" />
                                                        {/* {errors.name.length > 0 && <span className='text-danger'>{errors.name}</span>} */}
                                                    </div>
                                                </div>
                                                {/* <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">Profile Image</label>
                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-file-image"></i></span>
                                                        </div>
                                                        <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Image" />
                                                    </div>

                                                </div> */}
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">Employee Id</label>

                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                        </div>
                                                        <input type="text" disabled={true} onChange={this.onChangeInput} name="uniqueID" value={this.state.uniqueID} className="form-control" placeholder="Enter Employee ID" />
                                                        {/* {errors.name.length > 0 && <span className='text-danger'>{errors.uniqueID}</span>} */}
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">Designation</label>

                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                        </div>
                                                        <input type="text" onChange={this.onChangeInput} name="designation" value={this.state.designation} className="form-control" placeholder="Enter Designation" />
                                                        {/* {errors.name.length > 0 && <span className='text-danger'>{errors.designation}</span>} */}
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">Email</label>
                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-email"></i></span>
                                                        </div>
                                                        <input type="text" disabled={true} onChange={this.onChangeInput} value={this.state.email} name="email" className="form-control" placeholder="example@domain.com" />
                                                        {/* {errors.email.length > 0 && <span className='text-danger'>{errors.email}</span>} */}
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">Phone</label>
                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-phone"></i></span>
                                                        </div>
                                                        <input type="number" onChange={this.onChangeInput} name="phone" className="form-control" value={this.state.phone} placeholder="Enter Phone Number" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="form-group">
                                                <label for="exampleInputEmail1">Address</label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-account-card-details"></i></span>
                                                    </div>
                                                    <input type="text" value={this.state.address} onChange={this.onChangeInput} name="address" className="form-control" placeholder="Enter Address" />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">City</label>
                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-earth"></i></span>
                                                        </div>
                                                        <input type="text" value={this.state.city} onChange={this.onChangeInput} name="city" className="form-control" placeholder="Enter City Name" />
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label for="exampleInputEmail1">State</label>
                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-earth"></i></span>
                                                        </div>
                                                        <input type="text" value={this.state.stateAddress} onChange={this.onChangeInput} name="stateAddress" className="form-control" placeholder="Enter State Name" />
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label for="exampleInputEmail1">ZIP</label>

                                                    <div className="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i className="mdi mdi-numeric"></i></span>
                                                        </div>
                                                        <input type="number" value={this.state.zip} onChange={this.onChangeInput} name="zip" className="form-control" placeholder="Enter ZIP" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group ">
                                                <label for="exampleInputEmail1">Organizational Structure</label>
                                                <div className="form-row">
                                                    {/* {this.state.typeHierarchy.map((list, index) => <div>
                                                        {list.children.length > 0 ?
                                                            <div className="form-group float-left mr-4">
                                                                <label for="exampleInputEmail1">{list.label}</label>
                                                                <MultiDropDown index={index} data={list} onChange={this.onChangeDropdown} onAction={this.onAction} onNodeToggle={this.onNodeToggle} />
                                                            </div>
                                                            : null}
                                                    </div>)} */}
                                                    {/* {this.state.typeHierarchy.map((list, index) => <div> */}
                                                        {/* {list.children.length > 0 ? */}
                                                            <div className="form-group float-left mr-4">
                                                                {/* <label for="exampleInputEmail1">{list.label}</label> */}
                                                                <MultiDropDown index={0} data={this.state.typeHierarchy} onChange={this.onChangeDropdown} onAction={this.onAction} onNodeToggle={this.onNodeToggle} />
                                                            </div>
                                                            {/* : null} */}
                                                    {/* </div>)} */}

                                                </div>
                                            </div>


                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label for="exampleInputEmail1">User Type</label>

                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" defaultChecked={this.state.user_type == "SME" ? true : false} className="custom-control-input" id="defaultUnchecked" value="SME" name="user_type" />
                                                        <label class="custom-control-label" for="defaultUnchecked"> SME</label>
                                                    </div>

                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" className="custom-control-input" defaultChecked={this.state.user_type == "SME" ? false : true} value="Field Operator" id="defaultChecked1" name="user_type" />
                                                        <label class="custom-control-label" for="defaultChecked1">FO</label>
                                                    </div>
                                                </div>




                                                {/* <div className="form-group col-md-6">
                                                    <div class="form-group" id="rating-ability-wrapper">
                                                        <label class="control-label" for="rating">
                                                            <span class="field-label-header"> Rating </span><br />
                                                            <span class="field-label-info"></span>
                                                            <input type="hidden" id="selected_rating" name="selected_rating" value="" />
                                                        </label>
                                                        <h2 class="bold rating-header" >
                                                            <span class="selected-rating">0</span><small> / 5</small>
                                                        </h2>
                                                        <ul className="star-rating">
                                                            <li><button type="button" class="btnrating btn btn-default btn-lg" data-attr="1" id="rating-star-1">
                                                                <i class="fa fa-star" aria-hidden="true"></i>
                                                            </button></li>

                                                            <li><button type="button" class="btnrating btn btn-default btn-lg" data-attr="2" id="rating-star-2">
                                                                <i class="fa fa-star" aria-hidden="true"></i>
                                                            </button></li>

                                                            <li><button type="button" class="btnrating btn btn-default btn-lg" data-attr="3" id="rating-star-3">
                                                                <i class="fa fa-star" aria-hidden="true"></i>
                                                            </button></li>

                                                            <li><button type="button" class="btnrating btn btn-default btn-lg" data-attr="4" id="rating-star-4">
                                                                <i class="fa fa-star" aria-hidden="true"></i>
                                                            </button></li>

                                                            <li> <button type="button" class="btnrating btn btn-default btn-lg" data-attr="5" id="rating-star-5">
                                                                <i class="fa fa-star" aria-hidden="true"></i>
                                                            </button></li>
                                                        </ul>


                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <button type="submit" onClick={this.submit} className="btn btn-primary mr-3">Update</button>

                                                    <button type="submit" onClick={this.submitDelete} className="btn btn-primary mr-3">Move To Trash</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    : null}


            </div>
        )
    }
}
export default EditUser

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}